// Group a PDF page's positioned text items into visual lines — the ONE implementation, shared by
// planSearch.js (search / copy text) and scaleDetect.js (printed scale notes), and the layer any later
// drawing-schedule reading builds on. Callers feed it items from pdfRender.extractPageText
// ({ str, x, y }, viewport points, origin bottom-left).

/**
 * Group text items into visual lines. Items on one baseline (within yTol) join
 * left to right with a space; each line remembers where every item starts in the
 * joined string so a match can be located on the page.
 *   items: [{ str, x, y }]  ->  [{ text, x, y, parts: [{ start, end, x }] }]   (top line first)
 */
export function toIndexedLines(items, yTol = 2) {
  const rows = [];
  for (const it of items || []) {
    if (!it?.str || !String(it.str).trim()) continue;
    let row = rows.find(r => Math.abs(r.y - it.y) <= yTol);
    if (!row) { row = { y: it.y, items: [] }; rows.push(row); }
    row.items.push(it);
  }
  return rows
    .map(r => {
      const sorted = [...r.items].sort((a, b) => a.x - b.x);
      let text = "";
      const parts = [];
      for (const it of sorted) {
        if (text) text += " ";
        const start = text.length;
        text += String(it.str).trim();
        parts.push({ start, end: text.length, x: it.x });
      }
      return { text, x: sorted[0].x, y: r.y, parts };
    })
    .sort((a, b) => b.y - a.y || a.x - b.x);
}
